import React, { useEffect, useState } from 'react';
import { object, func, bool } from 'prop-types';
import { connect } from 'react-redux';
import { getTime, differenceInDays } from 'date-fns';
import get from 'lodash/get';
import wretch from 'wretch';
import { InfiniteStoryBase, LazyLoadImages } from '@quintype/components';

// import StoryBottomView from '../../story-templates/story-bottom-view';
// import BottomSideBar from '../../story-templates/bottom-side-bar';
import DesktopStickyAd from '../../molecules/desktop-sticky-ad';
import { callbackAfterPianoLoad } from '../../../helpers/piano-helpers';

import getTemplate from '../../story-templates/templates';
import { generateSignature } from '../../../helpers/generateWruSign';
import MoengageHelper from '../../../helpers/moengage-helper';
import { getThinmintId, sendCrmData } from '../../../helpers/story-helpers';
import { openLinkInNewTab, getTodayDate, getBqExclusiveStories } from '../../../helpers/utils';
import { trackArticleView } from '../../../helpers/datalayer-utils';
import { getBqBlueStories, getAboveFoldStories } from '../../../helpers/api';

import './story.m.css';

class ViewedStoriesStore {
  constructor(options = {}) {
    this.options = options;
    this.storageLimit = options.storageLimit || 20;
  }

  static build(options = {}) {
    if (!global.localStorage) {
      return {
        getViewedStoryIds: () => [],
        addViewedStoryId: () => {},
      };
    }
    return new ViewedStoriesStore(options);
  }

  getViewedStoryEntiries() {
    const viewedStoryIds = global.localStorage.getItem('viewed-stories');
    if (!viewedStoryIds || viewedStoryIds === '') {
      return [];
    }
    try {
      return JSON.parse(viewedStoryIds) || [];
    } catch (e) {
      return [];
    }
  }

  getViewedStoryIds() {
    return this.getViewedStoryEntiries().map((entry) => entry.id);
  }

  // private
  removeOldStoryIds(story) {
    const expiryTime = Date.now() - this.options.expiryTime || 8 * 60 * 60 * 1000;
    return story['viewed-at'] > expiryTime;
  }

  addViewedStoryId(storyId) {
    const viewedStories = this.getViewedStoryEntiries().filter(this.removeOldStoryIds.bind(this));

    if (viewedStories?.length >= this.storageLimit) {
      viewedStories?.shift();
    }

    viewedStories.push({
      'viewed-at': Date.now(),
      id: storyId,
    });

    global.localStorage.setItem('viewed-stories', JSON.stringify(viewedStories));
  }
}

const StoryPageBase = (props) => {
  const storyApiLimit = 50;
  const linkedStocks = get(
    props,
    ['data', 'story', 'cards', '0', 'metadata', 'attributes', 'ticker'],
    []
  );
  const [viewedStoriesStore, setViewedStoriesStore] = useState(null);
  const { selectedStoriesCollection, videoCollection, editorCollection } = props.bottomStoryData;
  const [topStoryIds, setTopStoryIds] = useState([]);
  const [isInfiniteScroll, setIsInfiniteScroll] = useState(false);
  const [qtypeSession, setQtypeSession] = useState([]);

  useEffect(() => {
    const { story } = props.data;
    const { tags = [] } = story;
    const storyTags = tags.map((t) => t.name);
    setQtypeSession(
      document.cookie.split('; ').filter((item) => item.startsWith('qtype-session='))
    );
    callbackAfterPianoLoad(() => {
      storyTags.push('bqStoryNewsletter');
      window.tp.push(['setTags', storyTags]);
      window.tp.experience.execute();
      // window.loadPiano(window.location.href);
    });

    trackArticleView(story, props.piano);

    if (global.COMSCORE) {
      global.COMSCORE.beacon(global.COMSCORE_OPTS);
    }

    openLinkInNewTab('.story-element a');

    // Piano migration check - start
    setViewedStoriesStore(
      ViewedStoriesStore.build({
        expiryTime: props.storySnapshotsConfig.expiry_time || null,
        storageLimit: Math.ceil(storyApiLimit / 2),
      })
    );
    // Piano migration check - end

    global.Moengage && MoengageHelper.storyView(story);
    global.Moengage && MoengageHelper.storyViewAttribute(story.headline);

    sendDataToCRM(props.member);
  }, []);

  useEffect(() => {
    if (viewedStoriesStore) {
      viewedStoriesStore.addViewedStoryId(props.data.story.id);
    }
  }, [viewedStoriesStore]);

  useEffect(() => {
    if (props?.member) {
      sendDataToCRM(props.member);
      // sendStoryViewEventToWru(props.member);
    }
  }, [props?.member?.uid]);

  useEffect(() => {
    if (props.data.bottomData) {
      const [selectedStoriesCollection, videoCollection, editorCollection] = get(
        props,
        ['data', 'bottomData', 'collection', 'items'],
        [null, null, null]
      );

      if (selectedStoriesCollection && selectedStoriesCollection.items) {
        const stories = selectedStoriesCollection
          ? getBqExclusiveStories(selectedStoriesCollection.items)
          : [];
        const ids = stories.map((c) => c.id);

        setTopStoryIds(ids);
      }

      props.setBottomStoryData({
        selectedStoriesCollection,
        videoCollection,
        editorCollection,
      });
    }
  }, [props.data.bottomData]);

  const sendDataToCRM = (member) => {
    const storyUrl = `${window.location.origin}/${props.data.story.slug}`;
    if (member) {
      const crmData = {
        uniqueID: member.uid,
        timestamp: getTodayDate('yyyy-MM-dd HH:mm:ss'),
        url: storyUrl,
        action: 'article_read',
      };
      sendCrmData(crmData);
    }
  };

  const sendStoryViewEventToWru = (member) => {
    const thinmintId = getThinmintId();
    // const secretKey = generateSignature(
    //   `${props.wru.host}/${props.wru['merchant-id']}/user`,
    //   props.wru.secret,
    //   'application/json'
    // );

    // wretch(`${props.wru.host}/${props.wru['merchant-id']}/user`)
    //   .headers({
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     Authorization: `Authorization me:${secretKey[0]}`,
    //     DateUsed: secretKey[1],
    //   })
    //   .post([
    //     {
    //       eventType: 'SUBSCRIBED_STORY_VIEW_EVENT',
    //       cid: props.data.story.id,
    //       uid: thinmintId, // thin mint id
    //       timestamp: getTime(new Date()).toString(),
    //       merchantId: `${props.wru['merchant-id']}`,
    //       widgetPlatform: 'web',
    //       payload: {
    //         user_details: {
    //           user_account_id: `${member.uid}`,
    //         },
    //       },
    //     },
    //   ]);
  };

  useEffect(() => {
    if (qtypeSession.length > 0) {
      // sendStoryViewEventToWruUnsub();
    }
  }, [qtypeSession]);

  const sendStoryViewEventToWruUnsub = () => {
    const thinmintId = getThinmintId();
    // const secretKey = generateSignature(
    //   `${props.wru.host}/${props.wru['merchant-id']}/user`,
    //   props.wru.secret,
    //   'application/json'
    // );

    // wretch(`${props.wru.host}/${props.wru['merchant-id']}/user`)
    //   .headers({
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     Authorization: `Authorization me:${secretKey[0]}`,
    //     DateUsed: secretKey[1],
    //   })
    //   .post([
    //     {
    //       cid: props.data.story.id,
    //       clientSessionId: qtypeSession[0].substring(qtypeSession[0].indexOf('=') + 1),
    //       eventType: 'STORY_VIEW_EVENT',
    //       merchantId: `${props.wru['merchant-id']}`,
    //       ref: '',
    //       timestamp: getTime(new Date()).toString(),
    //       uid: thinmintId, // thin mint id
    //       widgetPlatform: 'web',
    //     },
    //   ]);
  };

  useEffect(() => {
    if (props.member && linkedStocks?.length > 0) {
      linkedStocks?.map((stock) => {
        // sendSingleStockDataToWru(stock);
      });
    }
  }, [props?.member?.uid]);

  const sendSingleStockDataToWru = (stockDetails) => {
    const thinmintId = getThinmintId();
    // const secretKey = generateSignature(
    //   `${props.wru.host}/${props.wru['merchant-id']}/user`,
    //   props.wru.secret,
    //   'application/json'
    // );
    // wretch(`${props.wru.host}/${props.wru['merchant-id']}/user`)
    //   .headers({
    //     Accept: 'application/json',
    //     'Content-Type': 'application/json',
    //     Authorization: `Authorization me:${secretKey[0]}`,
    //     DateUsed: secretKey[1],
    //   })
    //   .post([
    //     {
    //       eventType: 'STOCK_VIEW_EVENT',
    //       ip: '',
    //       sessionId: '',
    //       cid: '',
    //       uid: thinmintId,
    //       userAgent: '',
    //       eid: '',
    //       pageViewEventId: '',
    //       timestamp: getTime(new Date()).toString(),
    //       merchantId: `${props?.wru['merchant-id']}`,
    //       payload: {
    //         user_details: {
    //           user_account_id: `${props?.member?.uid}`,
    //         },
    //         stock: {
    //           name: `${get(stockDetails, ['name'])}`,
    //           'stock-id': `${get(stockDetails, ['stock-id'])}`,
    //         },
    //       },
    //     },
    //   ]);
  };

  const onInitialItemFocusHandler = (item) => {
    setTimeout(() => {
      viewedStoriesStore.addViewedStoryId(item.story.id);
    }, 0);
  };

  const storyPageLoadItems = (pageNumber) => {
    if (props?.infiniteScroll) {
      if (isInfiniteScroll) return Promise.resolve([]);

      const latestStoriesPromise = getLatestStoryList(pageNumber);
      // const bqStoriesPromise = getBqBlueStoryList(pageNumber);

      return Promise.all([
        latestStoriesPromise,
        // bqStoriesPromise
      ]).then(([latestStories, bqBlueStories]) => {
        // Ensure both are arrays
        latestStories = Array.isArray(latestStories) ? latestStories : [];
        bqBlueStories = Array.isArray(bqBlueStories) ? bqBlueStories : [];

        const allStories = [];
        let i = 0;

        // Alternate between the two arrays
        while (i < latestStories.length || i < bqBlueStories.length) {
          if (i < bqBlueStories.length) {
            allStories.push(bqBlueStories[i]);
          }
          if (i < latestStories.length) {
            allStories.push(latestStories[i]);
          }
          i++;
        }

        setIsInfiniteScroll(true);

        return allStories;
      });
    } else {
      return Promise.resolve([]);
    }
  };

  const getLatestStoryList = (pageNumber) => {
    const fullStories = 1;
    const offset = storyApiLimit * pageNumber;

    return getAboveFoldStories(storyApiLimit, offset, topStoryIds)
      .get()
      .json(({ items = [] }) => items.map((item) => item.story))
      .then((stories) => {
        const viewedStoryIds = viewedStoriesStore.getViewedStoryIds();
        return stories.filter(
          (story) =>
            !viewedStoryIds.find((viewedStoryId) => viewedStoryId === story.id) &&
            !story.sections.find((section) => section.slug === 'exclusives') &&
            get(story, ['cards', 0, 'story-elements', 0, 'type'], '') === 'text'
        );
      })
      .then((stories) =>
        stories.map((story, index) => {
          story['story-template'] =
            pageNumber < fullStories - 1 && index < fullStories - 1
              ? story['story-template']
              : 'story-snapshot';
          return { story, otherProp: 'value' };
        })
      );
  };

  const getBqBlueStoryList = (pageNumber) => {
    const offset = storyApiLimit * pageNumber;

    return getBqBlueStories(storyApiLimit, offset, topStoryIds)
      .get()
      .json(({ items = [] }) => items.map((item) => item.story))
      .then((stories) => {
        const viewedStoryIds = viewedStoriesStore.getViewedStoryIds();

        return stories.filter(
          (story) =>
            !viewedStoryIds.find((viewedStoryId) => viewedStoryId === story.id) &&
            differenceInDays(new Date(), story['last-published-at']) <= 10 &&
            get(story, ['cards', 0, 'story-elements', 0, 'type'], '') === 'text'
        );
      })
      .then((stories) =>
        stories.map((story) => {
          story['story-template'] = 'bq-story-snapshot';
          return { story, otherProp: 'value' };
        })
      );
  };

  // eslint-disable-next-line react/display-name
  const getStoryTemplate =
    (hasAccess = true, updateAccess, isLoading, privateMode) =>
    ({
      // eslint-disable-next-line react/prop-types
      story,
      // eslint-disable-next-line react/prop-types
      singleVideoPageCollection,
      // eslint-disable-next-line react/prop-types
      mostRead,
      ...props
    }) => {
      // eslint-disable-next-line react/prop-types
      const Template = getTemplate(story['story-template']);

      // eslint-disable-next-line react/prop-types
      if (props.index === 0) {
        return (
          <div>
            <Template
              story={story}
              partialAccess={!hasAccess}
              updateAccess={updateAccess}
              isLoading={isLoading}
              privateMode={privateMode}
              singleVideoPageCollection={singleVideoPageCollection}
              mostRead={mostRead}
            />

            {/* <div styleName="story-bottom-view" className="story-page container">
            <StoryBottomView
              stories={
                selectedStoriesCollection
                  ? getBqExclusiveStories(selectedStoriesCollection.items)
                  : []
              }
            />
            <BottomSideBar videoCollection={videoCollection} editorCollection={editorCollection} />
          </div> */}
          </div>
        );
      }

      return (
        <div styleName="infinite-stories" className="container">
          <Template
            story={story}
            partialAccess={!hasAccess}
            updateAccess={updateAccess}
            isLoading={isLoading}
            privateMode={privateMode}
            singleVideoPageCollection={singleVideoPageCollection}
            mostRead={mostRead}
          />
        </div>
      );
    };

  if (props.preview) return getStoryTemplate()(props.data);

  return (
    <LazyLoadImages margin="50px">
      <InfiniteStoryBase
        {...props}
        neverHideItem={true}
        render={getStoryTemplate()}
        loadItems={storyPageLoadItems}
        onInitialItemFocus={(item) => onInitialItemFocusHandler(item)}
        doNotChangeUrl={true}
      />
      <DesktopStickyAd reduceZIndex />
    </LazyLoadImages>
  );
};

function mapStateToProps(state) {
  const { pianoUserDetails = {}, bottomStoryData } = state;

  return {
    loadedModules: state.loadedModules,
    userDetails: pianoUserDetails.member,
    userLoggedIn: !!pianoUserDetails.member,
    member: pianoUserDetails.member || null,
    userLoading: pianoUserDetails.isLoading || false,
    storySnapshotsConfig: state.qt.config.publisher.story_snapshots || {},
    subscription: state.qt.config.features.subscription || {},
    malibuHomePage: state.qt.config.features.malibu.home_page || false,
    meterShown: state.meterShown,
    // wru: state.qt.config.integrations.wru || {},
    piano: state.qt.config.integrations.piano || {},
    bottomStoryData: bottomStoryData || {},
    infiniteScroll: get(state, ['qt', 'config', 'integrations', 'story', 'infiniteScroll'], false),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendDmpStatus: () => {
      dispatch({
        type: 'BQ_SEND_DMP_STATUS',
      });
    },
    sendCurrentSectionName: (sectionName) => {
      dispatch({
        type: 'BQ_CURRENT_SECTION_NAME',
        value: sectionName,
      });
    },
    setBottomStoryData: (data) => {
      dispatch({
        type: 'BOTTOM_STORY_DATA',
        data,
      });
    },
  };
}

StoryPageBase.propTypes = {
  sendDmpStatus: func,
  loadedModules: object,
  userDetails: object,
  data: object.isRequired,
  sendCurrentSectionName: func,
  userLoggedIn: bool,
  storySnapshotsConfig: object,
  malibuHomePage: bool,
  preview: bool,
  subscription: object.isRequired,
  member: object,
  userLoading: bool,
  meterShown: bool.isRequired,
  // wru: object.isRequired,
  piano: object,
  setBottomStoryData: func,
  bottomStoryData: object,
  infiniteScroll: bool,
};

const StoryPage = connect(mapStateToProps, mapDispatchToProps)(StoryPageBase);

export { StoryPage };
